export const canvasWidth = 2000;
export const canvasHeight = 1000;
export const groundY = 800;
export const groundYStart = 900;
export const groundYEnd = 620;
export const groundSlope = (groundYStart - groundYEnd) / canvasWidth;
export const groundOffsetY = canvasHeight / 30;
export const msPerStep = 300;
